import { useEffect, useState } from "react";
import AppRoutes from "./routes";
import { ThemeProvider } from "./contexts/ThemeContext";
import { SidebarProvider } from "./contexts/SidebarContext";
import { apiFetch } from "@/lib/api/api";

// 1. Import the new hook and modal
import { useIdleTimeout } from "@/hooks/auth/useIdleTimeout";
import SessionTimeoutModal from "@/components/auth/SessionTimeoutModal";

function App() {
  // 2. Initialize the global 30-minute idle tracker
  useIdleTimeout(30);

  const [showMfaModal, setShowMfaModal] = useState(false);
  // const [mfaUserId, setMfaUserId] = useState<string | null>(null);
  const [verificationKey, setVerificationKey] = useState<string | null>(null);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  // Listen globally for MFA_REQUIRED
  useEffect(() => {
    const handler = (event: any) => {
      // setMfaUserId(event.detail.user_id);
      setVerificationKey(event.detail.verification_key);
      setShowMfaModal(true);
    };

    window.addEventListener("mfa-required", handler);

    return () => window.removeEventListener("mfa-required", handler);
  }, []);

  const handleVerifyMFA = async () => {
    if (!verificationKey) return;

    setLoading(true);

    try {
      const res = await apiFetch("/mfa/verify/", {
        method: "POST",
        body: JSON.stringify({
          verification_key: verificationKey,
          otp,
        }),
      });

      if (res.ok) {
        localStorage.setItem("mfa_verified", "true");
        setShowMfaModal(false);
        setOtp("");

        // Force clean reload so license + dashboard refetch
        window.location.reload();
      }
    } catch (err) {
      console.error("OTP verification failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <ThemeProvider>
      <SidebarProvider>
        <div className="min-h-screen bg-background-light dark:bg-background-dark transition-colors duration-200">
          <AppRoutes />
        </div>

        {/* GLOBAL MFA MODAL */}
        {showMfaModal && (
          <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
            <div className="bg-white dark:bg-gray-900 p-6 rounded-lg w-96 space-y-4">
              <h3 className="text-lg font-semibold">
                Enter Verification Code
              </h3>

              <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter OTP from email"
                className="w-full p-2 border rounded text-black"
              />

              <button
                onClick={handleVerifyMFA}
                disabled={loading}
                className="w-full bg-blue-600 text-white py-2 rounded"
              >
                {loading ? "Verifying..." : "Verify"}
              </button>
            </div>
          </div>
        )}

        {/* GLOBAL INACTIVITY MODAL */}
        <SessionTimeoutModal />

      </SidebarProvider>
    </ThemeProvider>
  );
}

export default App;